import { collection, doc, type CollectionReference, type DocumentReference } from 'firebase/firestore'
import { firebase } from '../lib/firebase'
import type { AppSettings, BlockDoc, PeriodNote, TagDoc, Taxonomy } from './types'
import type { IterationConfig } from './iterations'
import type { Tracker, TrackerDay } from './trackers'

export function blocksRef(uid: string): CollectionReference<BlockDoc> {
  return collection(firebase().db, 'users', uid, 'blocks') as CollectionReference<BlockDoc>
}

export function blockRef(uid: string, blockId: string): DocumentReference<BlockDoc> {
  return doc(firebase().db, 'users', uid, 'blocks', blockId) as DocumentReference<BlockDoc>
}

export function taxonomyRef(uid: string): DocumentReference<Taxonomy> {
  return doc(firebase().db, 'users', uid, 'settings', 'taxonomy') as DocumentReference<Taxonomy>
}

export function appSettingsRef(uid: string): DocumentReference<AppSettings> {
  return doc(firebase().db, 'users', uid, 'settings', 'app') as DocumentReference<AppSettings>
}

export function iterationsRef(uid: string): DocumentReference<IterationConfig> {
  return doc(firebase().db, 'users', uid, 'settings', 'iterations') as DocumentReference<IterationConfig>
}

export function tagsRef(uid: string): CollectionReference<TagDoc> {
  return collection(firebase().db, 'users', uid, 'tags') as CollectionReference<TagDoc>
}

export function tagRef(uid: string, tagId: string): DocumentReference<TagDoc> {
  return doc(firebase().db, 'users', uid, 'tags', tagId) as DocumentReference<TagDoc>
}

export function periodNoteRef(uid: string, id: string): DocumentReference<PeriodNote> {
  return doc(firebase().db, 'users', uid, 'periodNotes', id) as DocumentReference<PeriodNote>
}

export function trackersRef(uid: string): DocumentReference<{ trackers: Tracker[] }> {
  return doc(firebase().db, 'users', uid, 'settings', 'trackers') as DocumentReference<{
    trackers: Tracker[]
  }>
}

export function trackerDaysRef(uid: string): CollectionReference<TrackerDay> {
  return collection(firebase().db, 'users', uid, 'trackerDays') as CollectionReference<TrackerDay>
}

export function trackerDayRef(uid: string, id: string): DocumentReference<TrackerDay> {
  return doc(firebase().db, 'users', uid, 'trackerDays', id) as DocumentReference<TrackerDay>
}
